<template>
  <div class="wrapper">
    <div class="wrapper-header">
      <TabsWidget activeTab="account_settings" @selected="switchTab"></TabsWidget>
    </div>
    <div class="wrapper-body">
      <div class="header-panel">
        <div class="tabs-widget">
          <div class="tab-item" :class="{ active: activeTab == 'my_profile' }" @click="switchSubTab('my_profile')">
            MY PROFILE
          </div>
          <div class="h-spacer"></div>
          <div class="tab-item" :class="{ active: activeTab == 'security' }" @click="switchSubTab('security')">
            SECURITY SETTINGS
          </div>
          <div class="h-spacer"></div>
          <div v-if="account_type == 'streamer'" class="tab-item" :class="{ active: activeTab == 'keys' }" @click="switchSubTab('keys')">
            KEYS
          </div>
        </div>
      </div>
      <profileSettings v-if="activeTab == 'my_profile'"></profileSettings>
      <securitySettings v-if="activeTab == 'security'"></securitySettings>
      <keysSettings v-if="activeTab == 'keys' && account_type == 'streamer'"></keysSettings>
    </div>
  </div>
</template>

<script>
import profileSettings from "./components/profile_settings.vue";
import securitySettings from "./components/security_settings.vue";
import keysSettings from "./components/keys_settings.vue";
import TabsWidget from "./components/TabsWidget.vue"
export default {
  components: {
    profileSettings,
    securitySettings,
    TabsWidget,
    keysSettings
  },
  sockets: {},
  data: () => ({
    activeTab: "my_profile",
    account_type: null,
  }),
  watch: {},
  mounted() {
    let vm = this;
    vm.account_type = vm.$getLoggedUser().user.account_type;
  },
  methods: {
    switchTab(type) {
      let vm = this;
      vm.$emit("tab", type);
    },
    switchSubTab(tab) {
      let vm = this;
      vm.activeTab = tab;
    }
  },
};
</script>
<style lang="scss" scoped>
.wrapper {
  padding: 0px;
  display: flex;
  flex-direction: row;
  height: 100%;
  width: 100%;

  @media (max-width:650px) {
    flex-direction: column;
  }


  .wrapper-header {
    height: 100%;
    width: 250px;
    background: #fff;
    border-right: 1px solid #ddd;
  }

  .wrapper-body {
    width: calc(100% - 250px);
    display: flex;
    background: #fff;
    flex-direction: column;

    @media (max-width: 650px) {
      width: 100%;
      height: calc(100% - 70px);
    }

    .header-panel {
      height: 55px;
      border-bottom: 1px solid #ddd;

      .tabs-widget {
        display: flex;
        align-items: flex-end;
        margin-right: 15px;

        .h-spacer {
          margin-right: 20px;
        }

        .tab-item {
          cursor: pointer;
          padding: 14px 4px;
          border-bottom: 3px solid transparent;
          white-space: nowrap;

          &.active {
            color: var(--wecodefy-secondary-color, #9fc953);
            border-bottom: 3px solid var(--wecodefy-secondary-color, #9fc953);
          }
        }
      }
    }

  }
}
</style>
